import type { ReactNode } from "react"
import cx from "clsx"
import { Layout } from "../../../components/Layout"
import { ButtonLink } from "../../../components/ButtonLink"
import typography from "@rawa/ui/styles/typography.module.css"
import styles from "./KioskListLayout.module.scss"

type Props = {
  heading: string
  subtitle?: string
  back: { href: string; label: string }
  children: ReactNode
}

// The scaffold shared by the kiosk's list-picker pages (session list, group
// participants): a fixed <h1> (and optional subtitle) above a list that scrolls
// within the viewport, with a fixed "back" button below. Bounds itself to the
// viewport via Layout `fill` so a long list scrolls instead of growing the page
// and pushing the button off-screen.
export function KioskListLayout({ heading, subtitle, back, children }: Props) {
  return (
    <Layout fill>
      <div className={styles.container}>
        <h1
          className={cx(typography.h2, styles.heading, {
            [styles.headingWithSubtitle]: subtitle,
          })}
        >
          {heading}
        </h1>
        {subtitle && (
          <p className={cx(typography.bodyLarge, styles.subtitle)}>
            {subtitle}
          </p>
        )}
        <div className={styles.scroll}>{children}</div>
      </div>
      <ButtonLink href={back.href} className={styles.back}>
        {back.label}
      </ButtonLink>
    </Layout>
  )
}
